import { render, staticRenderFns } from "./CloudWhatsapp.vue?vue&type=template&id=dc89035c"
import script from "./CloudWhatsapp.vue?vue&type=script&lang=js"
export * from "./CloudWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports